import styled from '@emotion/styled'

export const PageHeader = styled.div`
  margin-bottom: 16px;
  padding: 16px 0 16px 0;
  border-bottom: 1px solid ${(props) => props.theme.navBorderBottomColor};
`
